/* eslint-disable no-console */
import { ENVIRONMENT } from './config';

// Looks like the SSO team are incapable of controlling their logging, and don't understand
// how impolite it is to pollute the logs of downstream apps. This is not perfect, since
// you loose the stack trace, but it makes the console useful again.

const isDevelopment = ENVIRONMENT === 'development';

if (isDevelopment) {
  const noop = () => {};

  // there is no great way to filter calls to groups selectively, they aren't used often
  // so they can be turned off with minimal impact
  console.group = noop;
  console.groupCollapsed = noop;

  console._log = console.log;

  console.log = function (first, ...rest) {
    // early return if this looks like it came from SSO
    if (typeof first === 'string' && first.match(/%c (\[QLoginWidget:|action|prev state|next state)/)) return;
    console._log(first, ...rest);
  };
}
